module.exports = __webpack_public_path__ + "static/media/content-03.5bd4c69d.png";